import { FieldValues, UseFormReturn, useWatch } from "react-hook-form";
import { useEffect, useRef, useState } from "react";
import AutocompleteField from "./AutoCompleteField";
import { FormReactiveAutocompleteField } from "../../types/form/form-types";

interface Props {
  field: FormReactiveAutocompleteField;
  form: UseFormReturn<FieldValues, any>;
}
export const ReactiveAutoCompleteField: React.FC<Props> = ({ field, form }) => {
  const {
    setValue,
    formState: { errors },
    control,
  } = form;
  const { reactive_key } = field;
  const initial_run = useRef(true);
  const [options, setOptions] = useState<any[]>([]);

  // const parent_value = watch(reactive_key);
  const parent_value = useWatch({ name: reactive_key, control });

  useEffect(() => {
    const _options = field.get_options(parent_value);
    setOptions(_options);
    if (initial_run.current === true) {
      initial_run.current = false;
      return;
    }

    setValue(field.id, field.multiple === true ? [] : "");
  }, [parent_value]);

  const error = field.id in errors;
  const error_message = errors?.[field.id]?.message ?? "";

  return (
    <AutocompleteField
      id={field.id}
      options={options}
      label={field.label}
      onChange={(value: any) => setValue(field.id, value)}
      required={field.required}
      multiple={field.multiple}
      disabled={Boolean(field.disabled)}
      error={error}
      helperText={error_message.toString()}
      {...form}
    />
  );
};
